import { useEffect } from 'react';
import { css } from '@emotion/react';
import { WeaveLogoNew } from '@frontend/assets';
import { Missing } from '@frontend/empty-states#svg';
import { useTranslation } from '@frontend/i18n';
import { sentry } from '@frontend/tracking';
import { theme } from '@frontend/theme';
import { Heading, Text, styles as dsStyles } from '@frontend/design-system';

interface Props {
  locationName: string;
}

export const BookingSiteInactivePage = ({ locationName }: Props) => {
  const { t } = useTranslation('bookingSite');

  // Log to Sentry when customer accesses inactive booking site
  useEffect(() => {
    sentry.warn({
      error: `Customer accessed inactive booking site for location: ${locationName}`,
      topic: 'booking-site',
      team: 'schedule',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <main css={[dsStyles.flexCenter, styles.main]}>
      <header css={[dsStyles.flexCenter, styles.header]}>
        <WeaveLogoNew />
      </header>
      <section css={styles.contentContainer}>
        <div css={[dsStyles.flexCenter, styles.content]}>
          <Missing height={250} />
          <Heading level={2}>{t('Not Available')}</Heading>
          <Text color='subdued' css={{ textAlign: 'center', margin: 0 }}>
            {t('{{locationName}} does not have an active online scheduling site.', { locationName })}
          </Text>
        </div>
      </section>
    </main>
  );
};

const styles = {
  main: css({
    flexDirection: 'column',
    height: '100vh',
  }),
  header: css({
    height: 120,
    width: '100%',
    borderBottom: `1px solid ${theme.colors.neutral20}`,
  }),
  contentContainer: css({
    flex: 1,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.colors.neutral5,
    padding: theme.spacing(0, 2),
  }),
  content: css({
    flexDirection: 'column',
    marginTop: theme.spacing(15),
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.neutral20}`,
    borderRadius: theme.borderRadius.large,
    width: 800,
    maxHeight: 400,
    padding: theme.spacing(4, 2),
  }),
};
